module.exports = __webpack_public_path__ + "img/chr_ts_4_penlight.94d16f45.png";